import type { HTMLAttributes } from 'react';
import { rowTone } from '../lib/rowTone';

/**
 * Case « Priorité / État » façon V1 : numéro de priorité en gras au-dessus,
 * état en entier dessous, centrés, fond de la couleur V1 (lib/rowTone,
 * couleurs dans index.css, .trow-prio[data-tone]). Partagée par la liste des
 * points (TicketRow) et la fiche d'un point (carte « État & classification »).
 *
 * `colored` à false : case transparente (réglage « Toute la ligne » de la
 * liste, où c'est la ligne qui porte la couleur).
 */
export function PrioEtatCase({
  priorite,
  etat,
  colored = true,
  className,
  ...rest
}: {
  priorite: number;
  etat: string;
  colored?: boolean;
} & HTMLAttributes<HTMLDivElement>) {
  const tone = colored ? rowTone(priorite, etat) : null;
  return (
    <div {...rest} className={`trow-prio${className ? ` ${className}` : ''}`} data-tone={tone ?? undefined}>
      <strong className="trow-prio-num">{priorite}</strong>
      <div className="trow-etat">{etat}</div>
    </div>
  );
}

/** Libellé en clair de la case, pour aria-label et title. */
export function prioEtatLabel(priorite: number, etat: string): string {
  return `Priorité ${priorite}, état ${etat}`;
}
